import withReportDownloadComponentStyle from "../components/ui/styles/StyledReportDownloadComponent";
import {useTranslation} from "react-i18next";
import {ReportFormat, DeviceActivationRequest} from "../models/report.model";
import {downloadDeviceActivation} from "../api/reporting-functions";
import {downloadFile} from "../utils/function-util";
import ReactsCard from "../components/ui/ReactsCard";
import Grid from "@material-ui/core/Grid";
import {Button, Typography} from "@material-ui/core";
import React from "react";

const DeviceActivationReport: React.FC = ({classes}: any) => {
    const {t} = useTranslation();

    const downloadStats = async () => {
        const request: DeviceActivationRequest = {
            format: ReportFormat.SPREADSHEET,
        }
        const {blob, filename} = await downloadDeviceActivation(request);
        downloadFile(blob, filename);
    };
    return (<ReactsCard title={t('DeviceActivation.Title')} className={classes.root}>
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Typography variant="subtitle1">
                    {t('DeviceActivation.Paragraph')}
                </Typography>
            </Grid>
            <Grid className={classes.dates} container item xs={12} md={9} lg={6} alignItems="center">
                <Grid item xs={4}>
                    <Button variant="contained" color="primary" size="medium"
                            onClick={downloadStats}>
                        {t('DeviceActivation.DownloadReport')}
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    </ReactsCard>);
};

export const StyleDeviceActivationReport = withReportDownloadComponentStyle(DeviceActivationReport);
